import { Component, AfterViewInit, ElementRef, EventEmitter, forwardRef, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NG_VALUE_ACCESSOR, NgControl } from '@angular/forms';
import { Observable ,  Subscription  } from 'rxjs';

import { ApiError, BaseTypeahead, BaseTypeaheadService, MessageService } from '../../../../core';
import { Transportadora } from '../transportadora';
import { TypeaheadTransportadoraHttpService } from './typeahead-transportadora-http.service';
import { isTransportadoraInativa } from '../transportadora-situacao';

import { TypeaheadMatch } from 'ngx-bootstrap/typeahead';
import { TransportadoraFilterModalComponent } from '../filter';

@Component({
    selector: 'sgt-typeahead-transportadora',
    templateUrl: './typeahead-transportadora.component.html',
    styleUrls: ['./typeahead-transportadora.component.less'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => TypeaheadTransportadoraComponent), multi: true },
    ]
})
export class TypeaheadTransportadoraComponent implements OnInit, AfterViewInit, BaseTypeahead<Transportadora> {
    @Input() entity: Transportadora;
    @Output() ngModelChange = new EventEmitter<Transportadora>();

    @Input() situacao: number; // Situação padrão
    @Input() required: any;
    @Input() disabled: any;
    @Input() readonly: any;
    @Input() ngControl: NgControl;
    @Input() autofocus = false;
    @Input() dropup = false;
    @Input() withAddonLeft: boolean;
    @Input() typeaheadOptionsInScrollableView = 5; // Quantidade de itens visíveis no no scroll do typeahead
    @Output() typeaheadChange = new EventEmitter<Transportadora>();
    @Output() entitySelected = new EventEmitter<Transportadora>(); // Emite evento quando a entidade foi selecionada no typeahead
    @Output() clearEntity = new EventEmitter<any>();


    @ViewChild('inputTypeahead', {static: true}) inputTypeahead: ElementRef;
    typeaheadOptionsLimit = 1000; // Quantidade máxima de registros exibidos no typeahead
    typeaheadSelected: string;
    typeaheadToken: string;
    typeaheadDataSource: Observable<Transportadora[]>;
    typeaheadNoResults: boolean;

    currentRequest: Subscription;
    isLoading: boolean;

    @ViewChild('transportadoraFilterModal') transportadoraFilterModal: TransportadoraFilterModalComponent;

    propagateChange: any = () => {};

    constructor(private baseTypeaheadService: BaseTypeaheadService,
                private messageService: MessageService,
                private typeaheadTransportadoraHttpService: TypeaheadTransportadoraHttpService) { }

    ngOnInit() {
        this.createDataSource();
    }

    ngAfterViewInit() {
        if (this.autofocus) {
            jQuery(this.inputTypeahead.nativeElement).focus();
        }
    }

    /** Cria o data source do typeahead */
    createDataSource() {
        this.typeaheadDataSource = Observable.create((observer: any) => {
            if (this.currentRequest) {
                this.currentRequest.unsubscribe();
            }

            this.currentRequest = this.typeaheadTransportadoraHttpService.search(this.typeaheadToken, this.situacao, this.typeaheadOptionsLimit)
                                        .subscribe(
                                            (entities: Transportadora[]) => observer.next(entities),
                                            (error: ApiError) => {
                                                this.messageService.error(error.message, 'Ocorreu um erro ao pesquisar as transportadoras. Tente novamente', error);
                                                observer.next([]);
                                            }
                                        );
        });
    }


    /** Ao digitar no input do typeahead */
    onKeyup(e: KeyboardEvent) {
        this.baseTypeaheadService.onKeyup(this, e);
    }

    /** Ao sair do input do typeahead */
    onBlur() {
        this.baseTypeaheadService.onBlur(this);
        if (!this.entity) {
            this.clearEntity.emit();
        }
    }


    /** Verifica se o typeahead possui resultados */
    onChangeTypeaheadNoResults(noResults: boolean) {
        this.typeaheadNoResults = noResults;
    }

    /** Ao selecionar o Transportadora no typeahead */
    onSelectEntity(tm: TypeaheadMatch) {
        this.baseTypeaheadService.onSelectEntity(this, tm);
        this.entitySelected.emit(this.entity);
    }

    /** Ao selecionar o Transportadora no modal de pesquisa */
    onSelectEntityModal(transportadora: Transportadora) {
        if (transportadora) {
            this.entity = transportadora;
        } else {
            this.entity = null;
        }

        this.propagateChange(this.entity);
        this.typeaheadChange.emit(this.entity);
        this.entitySelected.emit(this.entity);
        this.writeValue(this.entity);
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

    /** Limpa o typeahead e o model */
    clear() {
        this.baseTypeaheadService.clear(this);
        this.clearEntity.emit();
    }

    /** Seta o foco no input */
    setFocus() {
        jQuery(this.inputTypeahead.nativeElement).focus();
    }

    /** Abre o modal de pesquisa */
    search() {
        this.transportadoraFilterModal.open();
    }

   /** Quando recebe um objeto Transportadora de "fora" do component */
    writeValue(value: Transportadora) {
        if (value) {
            this.baseTypeaheadService.writeValue(this, value, value.pessoa.nome);
        } else {
            this.baseTypeaheadService.writeValue(this, null);
        }
    }

    /** Propaga as alterações */
    registerOnChange(fn) {
        this.propagateChange = fn;
    }

    registerOnTouched() {}

    /** Verifica se a situação da transportadora é inativa */
    isInativa(situacao: number): boolean {
        return isTransportadoraInativa(situacao);
    }
}
